import React from 'react'
import "./worldMap.css"
import Floater from '../../../components/Floaters/Floater'
function WorldMap() {
    return (
        <section className='WorldMap'>
        <Floater />
            <div className='content-wp'>
            <div className='icon-circle gradient-danger  mb-50'>
            
<span className="material-symbols-outlined local_shipping_icon">
dvr
</span>
            </div>
                <div className="numbers">
                    
                    <div className="num">2</div>
                    <div className="num">9</div>
                    <div className="vir">,</div>
                    <div className="num">0</div>
                    <div className="num">1</div>
                    <div className="num">4</div>
                </div>
                <h3 className='text'>Students have already started their journey to success</h3>
                <h1 className='text'><b>Take the Next Step Toward Your Dream Job Now!</b></h1>
                <p className='text' style={{fontSize: "1.8rem"}}>Prepare with <b>150</b> curated questions that have helped many succeed in their tech interviews. For just <b>₹2 per question</b>, you can gain the skills you need to land your dream job in tech.</p>

                {/* <p className='text'>Don’t miss out on this opportunity to prepare with curated questions that have helped many succeed in their tech interviews. For just ₹2 per question, you can gain the skills you need to land your dream job in tech.</p> */}
            </div>

        </section>
    )
}

export default WorldMap